import React from 'react';
import './TeamSection.css';
import diegoImage from '../assets/diego.png'; 
import crismarImage from '../assets/crismar.png';
import aldairImage from '../assets/aldair.png';

const TeamSection = () => {
  const teamMembers = [
    { name: "Diego Palacios", title: "Coo-Founder & CEO", image: diegoImage }, 
    { name: "Crismar Cruz", title: "Coo-Founder & CEO", image: crismarImage },
    { name: "Aldair Cruz", title: "Ingeniero de software", image: aldairImage },
  ];

  return (
    <section className="team-section">
      <div className="container">
        <h2>Nuestro equipo</h2>
        <p>
          Nuestro equipo está formado por personas apasionadas, comprometidas y expertas en
          distintas áreas, desde el desarrollo de software hasta el diseño, la gestión de proyectos y
          la atención al cliente. Trabajamos en conjunto para transformar ideas en soluciones
          innovadoras y de calidad.
        </p>
        <div className="team-members-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member-card">
              <img src={member.image} alt={member.name} className="member-photo" />
              <h3>{member.name}</h3>
              <p>{member.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;